var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFwArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20898 8.99996H12.379L7.49898 13.88C7.10898 14.27 7.10898 14.91 7.49898 15.3C7.88898 15.69 8.51898 15.69 8.90898 15.3L15.499 8.70996C15.889 8.31996 15.889 7.68996 15.499 7.29996L8.91898 0.699956C8.73215 0.512704 8.4785 0.407471 8.21398 0.407471C7.94947 0.407471 7.69582 0.512704 7.50898 0.699956C7.11898 1.08996 7.11898 1.71996 7.50898 2.10996L12.379 6.99996H1.20898C0.658984 6.99996 0.208984 7.44996 0.208984 7.99996C0.208984 8.54996 0.658984 8.99996 1.20898 8.99996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwArrow);
export default __webpack_public_path__ + "static/media/fw-arrow.5f1a5734b1661fbb73c38ed8573a6ef7.svg";
export { ForwardRef as ReactComponent };